import DeleteIcon from "@mui/icons-material/Delete";
import ReactFlow, { Handle, Position } from "reactflow";

const GateNode = ({ id, data, deleteNode }) => {
  return (
    <div
      className="relative w-20 h-12 bg-gradient-to-br from-gray-700 via-gray-800 to-gray-900 border border-gray-600 rounded-lg shadow-xl flex items-center justify-center"
      // className="relative w-32 h-24 bg-gray-900 text-white border-2 border-green-500 rounded-lg flex items-center justify-center shadow-md"
    >
      <span className="font-bold text-lg">{data.label}</span>
      {data.inputs.map((inputId, index) => (
        <Handle
          key={`input-${index}`}
          type="target"
          id={`input-${index + 1}`} // Unique input handles
          position={Position.Bottom}
          style={{
            left: `${(index + 1) * (100 / (data.inputs.length + 1))}%`,
            bottom: "-5px",
          }}
        />
      ))}
      <button
        onClick={() => deleteNode(id)}
        className="absolute top-0 right-0 bg-red-600 text-white rounded-full w-5 h-5 text-sm flex items-center justify-center"
      >
        <DeleteIcon />
      </button>
      <Handle type="source" id="output" position={Position.Top} />
    </div>
  );
};

export default GateNode;
